@let currentDraft = draft();

<div class="grid grid-cols-1 gap-[1.5rem] px-[1.25rem] py-[0.75rem] md:grid-cols-2"
     [formGroup]="form">
  <div class="flex flex-col gap-[1rem] min-w-0">
    <div class="flex flex-col gap-[0.375rem]">
      <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)">
        <span translate="@@shared-events-assignee__text"></span>
      </span>

      <!-- saved as soon as it is picked, apart from the rest of the draft -->
      <p-select #select
                panelStyleClass="p-special"
                formControlName="assignedTo"
                [styleClass]="'w-full p-special !h-[2.75rem]'"
                [overlayOptions]="overlayOptions"
                [options]="assigneeOptions()"
                optionLabel="label"
                optionValue="value">
        <ng-template #selectedItem let-selectedOption>
          @if (selectedOption) {
            <div class="flex items-center gap-2 text-(--p-gray-950)">
              {{ selectedOption.label }}
            </div>
          }
        </ng-template>

        <ng-template #item let-option>
          <div class="flex items-center gap-[0.5rem]">
            @if (option.value === currentDraft.assignedTo) {
              <svg-icon class="original-icon block shrink-0" src="icons/icon-checked.svg" name="icon-checked"></svg-icon>
            } @else {
              <span class="block size-[1rem] shrink-0 rounded-full border border-(--p-gray-200)"></span>
            }
            <span>{{ option.label }}</span>
          </div>
        </ng-template>

        <ng-template #dropdownicon>
          @if (select.overlayVisible) {
            <svg-icon class="block size-[0.625rem]" src="icons/icon-accordion-arrow-up.svg" name="icon-accordion-arrow-up"></svg-icon>
          } @else {
            <svg-icon class="block size-[0.625rem]" src="icons/icon-accordion-arrow-down.svg" name="icon-accordion-arrow-down"></svg-icon>
          }
        </ng-template>
      </p-select>
    </div>

    <div class="flex flex-col gap-[0.375rem]">
      <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)"
            translate="@@fp-event-field__location"></span>

      <gc-dialog-event-location-card></gc-dialog-event-location-card>
    </div>

    <p-button [text]="true"
              severity="contrast"
              class="flex self-start"
              styleClass="group !h-[2rem] mt-1 !gap-[0.5rem] !rounded-[0.25rem] !border !border-transparent !bg-(--p-surface-0) !px-[0.4375rem] !py-[0.1875rem] !text-[0.75rem] !font-medium !text-(--p-blue-500) hover:!border-(--p-blue-100) hover:!bg-(--p-neutral-500) active:!border-(--p-blue-500) active:!bg-(--p-blue-500) active:!text-(--p-surface-0)"
              (onClick)="goToComments()">
      <span class="inline-flex items-center gap-[0.25rem]">
        <svg-icon src="icons/icon-comment.svg" name="icon-comment" class="size-[1.25rem] shrink-0"></svg-icon>

        <span translate="@@fp-event-quick-link__comments"></span>
      </span>

      @let commentCount = history.userCommentCount();

      <!-- blue once there are comments; with none, white on the hovered button and grey again once pressed.
           A pressed button is blue itself, so a blue counter turns white on it -->
      <span class="inline-flex h-[1.5rem] min-w-[1.5rem] items-center justify-center rounded-[0.375rem] px-[0.5rem]"
            [class]="commentCount
              ? 'bg-(--p-blue-500) text-(--p-surface-0) group-active:bg-(--p-surface-0) group-active:text-(--p-blue-500)'
              : 'bg-(--p-other-gray-50) text-(--p-gray-500) group-hover:bg-(--p-surface-0) group-active:bg-(--p-other-gray-50)'">{{ commentCount }}</span>
    </p-button>
  </div>

  <gc-dialog-event-investigation-result class="min-w-0"></gc-dialog-event-investigation-result>
</div>
